<script>
  import AboutScreen from '../../../module_core/module_about/about.screen.svelte'
</script>

<svelte:head>
  <title>Sobre a Lutruvials | Especialistas em Desenvolvimento de Sistemas</title>
  <meta
    name="description"
    content="Opa, Tudo bom?. A gente construiu a empresa para turbinar soluções customizadas. Se sua empresa é do Brasil você tem muita sorte da gente estar aqui. Nós confiamos e trazemos segurança pra nossos semelhantes, Criando aplicações de Bate-Volta. Sim isso mesmo rápidas. Sem muita conversa fiada, sem dores de cabeça."
  />

  <!-- Primary Meta Tags -->

  <!-- Open Graph / Facebook -->
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://lutruvials.com/" />
  <meta
    property="og:title"
    content="Sobre a Lutruvials | Especialistas em Desenvolvimento de Sistemas"
  />
  <meta property="og:site_name" content="lutruvials" />
  <!-- prettier-ignore -->
  <meta property="og:description" content={'"Opa, Tudo bom?. A gente construiu a empresa para turbinar soluções customizadas. Se sua empresa é do Brasil você tem muita sorte da gente estar aqui. Nós confiamos e trazemos segurança pra nossos semelhantes, Criando aplicações de Bate-Volta. Sim isso mesmo rápidas. Sem muita conversa fiada, sem dores de cabeça.'} />
  <meta property="og:image" content="/jpeg/hero-banner.jpg" />

  <!-- X (Twitter) -->
  <meta property="twitter:card" content="/jpeg/hero-banner.jpg" />
  <meta property="twitter:url" content="https://lutruvials.com/" />
  <meta
    property="twitter:title"
    content="Sobre a Lutruvials | Especialistas em Desenvolvimento de Sistemas"
  />
  <meta
    property="twitter:description"
    content={'"Opa, Tudo bom?. A gente construiu a empresa para turbinar soluções customizadas. Se sua empresa é do Brasil você tem muita sorte da gente estar aqui. Nós confiamos e trazemos segurança pra nossos semelhantes, Criando aplicações de Bate-Volta. Sim isso mesmo rápidas. Sem muita conversa fiada, sem dores de cabeça.'}
  />
  <meta property="twitter:image" content="/jpeg/hero-banner.jpg" />
</svelte:head>

<AboutScreen />
